import { IUserProps } from '../../types/User';

/**
 * Check if user has completed BVN verification
 * BVN is considered complete if bvnInfo exists and has required fields
 */
export function isBvnComplete(user: IUserProps | null): boolean {
  if (!user) return false;
  
  // Check if bvnInfo exists and has essential data
  if (user.bvnInfo && user.bvnInfo.bvn) {
    return true;
  }
  
  // Also check if bankVerificationNumber exists as a fallback
  if (user.bankVerificationNumber) {
    return true;
  }

  // Finally, treat a verified BVN selfie (including admin waiver) as BVN complete
  if (user.isBvnImageVerified) {
    return true;
  }
  
  return false;
}

/**
 * Check if user has completed BVN image verification
 * User must have completed BVN profile verification AND image verification
 */
export function isBvnImageVerified(user: IUserProps | null): boolean {
  if (!user) return false;
  
  // First check if BVN profile is complete
  if (!isBvnComplete(user)) {
    return false;
  }
  
  // Then check if image is verified
  return user.isBvnImageVerified === true;
}


